import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import NivelReprocesamiento from './NivelReprocesamiento';





interface NivelReprocesamientoTableProps {
  data: NivelReprocesamiento[];
  columns: TableColumn<NivelReprocesamiento>[];
  customStyles: Record<string, any>;
}

const NivelReprocesamientoTable: React.FC<NivelReprocesamientoTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<NivelReprocesamiento>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default NivelReprocesamientoTable;